var React = require('react');

function EllipseInline (props) {
    return React.createElement("svg",props,[React.createElement("radialGradient",{"id":"radial-gradient","cx":"0.416","cy":"0.43","r":"0.5","gradientUnits":"objectBoundingBox","key":0},[React.createElement("stop",{"offset":"0","stopColor":"#db3594","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#ba2b7d","key":1})]),React.createElement("circle",{"id":"Ellipse_221","data-name":"Ellipse 221","cx":"59","cy":"59","r":"59","transform":"translate(118 118) rotate(180)","fill":"url(#radial-gradient)","key":1})]);
}

EllipseInline.defaultProps = {"width":"118","height":"118","viewBox":"0 0 118 118"};

module.exports = EllipseInline;

EllipseInline.default = EllipseInline;
